import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import i18n from './lang/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import animate from 'animate.css'
import 'animate.css'
import { WOW } from "wowjs";
import './assets/icons'

Vue.use(ElementUI);
// Vue.use(animate)

// Vue.use(echarts)
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)
import "./style/index.scss";

import VueLazyload from 'vue-lazyload'
// import { from } from 'core-js/fn/array'

Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/Loading1.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间

axios.defaults.timeout = 20000

//设置api地址
//全局定义axios
//  axios.defaults.baseURL = 'http://127.0.0.1:8888/api/'
axios.defaults.baseURL ="http://wing.daovay.cn/prod-api/api/";
axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.prototype.$http = axios
Vue.prototype.$headerTab=0;
// // 图片服务器地址
Vue.prototype.imgserver = axios.defaults.baseURL
Vue.prototype.$wow = new WOW({
  boxClass: "wow", //需要执行动画元素的Class
  animateClass: "animated", //animation.css动画的Class
  live: true, //异步加载的内容是否有效
  offset: 200,
});
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')